import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "~/utils";
import { Text } from "~/components/text";

export const BooksTableHeader = ({
  actions,
  header,
  selectedCount,
  isSelectedAll,
}: {
  selectedCount?: number;
  isSelectedAll?: boolean;
  actions?: React.ReactNode;
  header?: React.ReactNode;
}) => {
  const { t } = useTranslation(["components"]);

  return (
    <div className="grid grid-cols-[1fr_auto] gap-4">
      {header}

      <div
        className={cn(
          "grid grid-cols-[auto_auto] items-center",
          Boolean(selectedCount) && "space-x-4",
        )}
      >
        {Boolean(selectedCount) && (
          <Text as="div" variant="muted" className="text-nowrap">
            {isSelectedAll
              ? t("components:booksTable.allSelected", { count: selectedCount })
              : t("components:booksTable.selected", { count: selectedCount })}
          </Text>
        )}
        {actions}
      </div>
    </div>
  );
};
